import { SiteFooter } from '@/components/SiteFooter';

export default function LandingFooter() {
  return <SiteFooter />;
}
